import { render, staticRenderFns } from "./Personal_data.vue?vue&type=template&id=cf21adfc&scoped=true"
import script from "./Personal_data.vue?vue&type=script&lang=js"
export * from "./Personal_data.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/user_center.css?vue&type=style&index=0&id=cf21adfc&prod&scoped=true&lang=css&external"
import style1 from "./Personal_data.vue?vue&type=style&index=1&id=cf21adfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf21adfc",
  null
  
)

export default component.exports